import { render } from "./ItemOrServiceItem.vue?vue&type=template&id=34fe6882"
import script from "./ItemOrServiceItem.vue?vue&type=script&lang=js"
export * from "./ItemOrServiceItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__